import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CVEConfig } from 'it/primatoo/openapi/api/org/schemas/cybersecurity/_appauditcve/_cveaudit/CVEConfig';

@Component({
  selector: 'pt-cve-details-table',
  template: `
    <div class="table-cve-details">
      <table class='table table-striped table-sm m-0 w-100 overflow-auto'>
        <thead>
        <tr>
          <th scope='col' class='font-12' style="font-weight: 500;">{{ 'CVE_DETAIL_TABLE.NAME' | translate }}</th>
          <th scope='col' class='font-12' style="font-weight: 500;">{{ 'CVE_DETAIL_TABLE.VERSION' | translate }}</th>
          <th scope='col' class='font-12 text-center' style="font-weight: 500;">{{ 'CVE_DETAIL_TABLE.PRESENT' | translate }}</th>
          <th scope='col' class='font-12 text-center' style="font-weight: 500;">{{ 'CVE_DETAIL_TABLE.NOT_PRESENT' | translate }}</th>
          <th scope='col' class='font-12 text-center' style="font-weight: 500;">{{ 'CVE_DETAIL_TABLE.NULL' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor='let v of localCve'>
          <td class="font-12">{{ v.name }}</td>
          <td class="font-12">{{ v.version }}</td>
          <td class="font-12 text-center">
            <div class="form-check custom-form-checkbox">
              <input class="form-check-input" type="radio"
                     [value]="true"
                     [disabled]="readonly"
                     [name]="'cve_'+v.uuid"
                     [ngModel]="v.present"
                     (ngModelChange)="updateCvePresent(v, true)">
            </div>
          </td>
          <td class="font-12 text-center">
            <div class="form-check custom-form-checkbox">
              <input class="form-check-input" type="radio"
                     [name]="'cve_'+v.uuid"
                     [disabled]="readonly"
                     [value]="false"
                     [ngModel]="v.present"
                     (ngModelChange)="updateCvePresent(v, false)">
            </div>
          </td>
          <td class="font-12 text-center">
            <div class="form-check custom-form-checkbox">
              <input class="form-check-input" type="radio"
                     [name]="'cve_'+v.uuid"
                     [disabled]="readonly"
                     [value]="null"
                     [ngModel]="v.present"
                     (ngModelChange)="updateCvePresent(v, null)">
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!--        <b>NOTE: qui finisce il dto AppAuditCve giusto? nel caso manca la versione</b>-->

  `,
  styles: [`
    .custom-form-checkbox {
      padding-top: 0;
      padding-bottom: 0;
      margin: 0;
      font-size: 10px;
      zoom: 0.8;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .table-cve-details {
      max-height: 120px;
      width: 100%;
      overflow-y: auto;
    }
  `]
})
export class CveDetailsTableComponent implements OnChanges {

  @Input() cveConfig?: CVEConfig[];
  @Input() readonly = false;

  @Output() updateAppAuditCve: EventEmitter<CVEConfig[]> = new EventEmitter<CVEConfig[]>();

  public localCve: CVEConfig[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.localCve = JSON.parse(JSON.stringify(this.cveConfig))
  }

  updateCvePresent(input: CVEConfig, present: boolean | null) {
    const newCve: CVEConfig[] = [];
    this.localCve.forEach((cve: CVEConfig) => {
      if (cve.uuid === input.uuid) {
        newCve.push({
          ...cve,
          present: present
        });
      } else {
        newCve.push(cve);
      }
    });
    this.localCve = newCve;
    this.updateAppAuditCve.emit(newCve);
  }
}

